// @flow

//
// React
//
import React from 'react';

//
// Type
//
import {
    type CellRendererFactoryProps,
    type CellProps,
} from '../types/CellProps';

//
// Formatter
//
import { fmtPercent } from '../../../../trix-web-data-commons';

//
// Helper
//
import { renderAsLink } from './tools';

//
// Component
//
const createPercentCellRenderer = (cfg: CellRendererFactoryProps): any => (props: CellProps): any => {
    return (
        <div>
            {renderAsLink(cfg.onClick, props.row)(fmtPercent(props.value))}
        </div>
    );
};
export default createPercentCellRenderer;
